import React from "react";
import { withRouter } from "../_shared/withRouter";
import VerifyAccount from "../template/auth/verifyAccount";

const VerifyAdmin = (props) => {
  return <VerifyAccount role={"2"} roleType={"admin"} />;
};

export default withRouter(VerifyAdmin);
